export default __webpack_public_path__ + "static/media/Play.d501c594.svg";